import styled from 'styled-components';
import contactbackground from "../assets/2022/photos/Contactez-nous/contactbackground.jpeg";

const Wrapper = styled.div`


.header{
  position: relative;
  background: url(${contactbackground});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;

  @media(min-width: 2000px){
    background-position: 0 -20em;
  }

  background-size: cover;
  background-position: top;
  position: relative;
  z-index: 0;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  justify-content: center;
  padding: 0 1.75em;

  &::before{
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: rgba(0,0,0,0);
    z-index: -1;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;

  h3{
    margin: 0;
    font-weight: 1000;
    font-size: 26px;
    text-transform: uppercase;
    text-align: left;
    font-style: italic;
  }

  p{

    font-weight: 600;
    font-size: 3em;
    @media(max-width: 1024px){
    font-size: 2em;
    }
  }

  h3,p{
    color: white;
    ;
  }

}

.content{

  padding: 3em 15px;

    .flex-wrap{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: row;
      padding-bottom: 3em;
    }


    h1{
      margin: 20px 0 15px;
      font-size: 42px;
      padding: 0;
      font-weight: 500;
      color: #009444;
      text-align: left;
      font-family: Poppins;
      width: 200px;
    }

    .text-content{
      font-weight: 500;
      color: black;
      font-family: Poppins;
      text-align: left;
      font-size: 21px;
      line-height: 36px;
      margin-top: 0;
      margin-bottom: 10px;
      letter-spacing: 1px;
    }


    a.option{
      text-decoration: none;
      width: 100%;
      padding: 1em 0;
      color: black;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid #009444;
      font-size: 23px;
    }

  }

  .form-content{

    form{

      .form-control{
        padding: 1em 0;
      }

      @media(min-width: 768px){
        .form-control{
          padding-right: 1em;
        }
      }

      label, input, select {
        line-height: 22px;
        font-size: 18px;
      }

      input, select, textarea {
        padding: 0.65em 0;
        width: 100%;
        border: 0;
        border-bottom: 2px solid #009444;
        outline: none;
        border-radius: 0;
      }

      button{
        background-color: #009444;
        color: #fff;
        font-family: Poppins;
        border-radius: 20px;
        text-transform: uppercase;
        padding: 10px 30px;
        font-weight: 500;
        border: 2px solid #009444;
        font-size: 18px;
      }

      textarea{
        height: 250px;
        width: 100%;
        padding: 1em 1em 1em 0.15em;
        font-size: 18px;
        line-height: 22px;
        font-family: Arial;
        letter-spacing: 0.5px;
      }

    }
  }

}

@media(max-width: 768px){

  .header{
      padding: 0;
      height: 250px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
  }

  p, li, span{
    font-size: 14.5px !important;
    line-height: 30px !important;
  }

  .header h3{
    font-size: 21px;
  }

  .header h3, .header p{
    margin-left: 1em !important;
  }

  .header p{
    font-size: 1.25em !important;
      line-height: 1.7em !important;
      letter-spacing: 0.75px;
      font-weight: 600;
  }

}

.cjsx{
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: row;

  @media(max-width: 1024px){
    flex-direction: column;
  }

}
#submit{

  flex-direction: row !important;
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 150px;
  padding-left: 0 !important;
  padding-right: 0 !important;

  span{
    margin-left: 1em;
  }

}


`;

export default Wrapper;



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/contact.style.js